import { authState } from "../auth.ts";
import { refreshUnread, unreadCount } from "../notifications.ts";
import { profilePath } from "../router.ts";

export function Navigation(): Element {
  const nav = <nav class="site-nav" aria-label="Primary navigation"></nav>;
  const badge = <span class="nav-badge" hidden></span> as HTMLElement;
  unreadCount.subscribeImmediate((count) => {
    badge.hidden = !(count && count > 0);
    badge.textContent = !count || count <= 0 ? "" : count > 99 ? "99+" : String(count);
  });
  setInterval(() => void refreshUnread(), 30000);
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) void refreshUnread();
  });
  authState.subscribeImmediate((state) => {
    void refreshUnread();
    const profile = state.status === "authenticated"
      ? (
        <a href={profilePath(state.did)} dataset={{ route: "" }}>
          <span class="nav-icon nav-profile" aria-hidden="true"></span>
          <span>Profile</span>
        </a>
      )
      : (
        <span aria-disabled="true">
          <span class="nav-icon nav-profile" aria-hidden="true"></span>
          <span>Profile</span>
        </span>
      );
    const bell = state.status === "authenticated"
      ? (
        <a href="/notifications" dataset={{ route: "" }}>
          <span class="nav-icon-badged">
            <span class="nav-icon nav-bell" aria-hidden="true"></span>
            {badge}
          </span>
          <span>Notifications</span>
        </a>
      )
      : (
        <span aria-disabled="true">
          <span class="nav-icon nav-bell" aria-hidden="true"></span>
          <span>Notifications</span>
        </span>
      );
    nav.replaceChildren(
      <a href="/" dataset={{ route: "" }}>
        <span class="nav-icon nav-home" aria-hidden="true"></span>
        <span>Home</span>
      </a>,
      <a class="nav-search-link" href="/search" dataset={{ route: "" }}>
        <span class="nav-icon nav-search" aria-hidden="true"></span>
        <span>Search</span>
      </a>,
      bell,
      profile,
    );
  });
  return nav;
}
